/*
 * Trak Racer — route the "Custom Contact Form V2" section to Zendesk.
 *
 * Progressive enhancement: the Shopify {% form 'contact' %} still renders and
 * still works if this script fails to load (it falls back to Shopify's email
 * route). When the script runs, it intercepts submit and POSTs the fields to
 * the FastAPI proxy, which creates a Corsair Zendesk ticket.
 *
 * Setup (see INTEGRATION.md):
 *   1. Host this file as a theme asset (assets/contact-proxy.js).
 *   2. Set the endpoint via a data attribute on the form's wrapper, or a global:
 *        <script>window.TR_CONTACT_PROXY_URL = "https://<railway-domain>/api/contact";</script>
 *   3. Add the hidden honeypot input to the Liquid form (name must match the
 *      server HONEYPOT_FIELD, default "company_extra").
 */
(function () {
  "use strict";

  var ENDPOINT =
    window.TR_CONTACT_PROXY_URL ||
    document.currentScript?.getAttribute("data-endpoint") ||
    "";

  var HONEYPOT = window.TR_CONTACT_HONEYPOT || "company_extra";

  function enhance(form) {
    if (!ENDPOINT) return; // no endpoint configured -> leave native behaviour
    if (form.dataset.zdEnhanced) return;
    form.dataset.zdEnhanced = "1";

    // Ensure a honeypot exists (hidden from humans, tempting to bots).
    if (!form.querySelector('[name="' + HONEYPOT + '"]')) {
      var hp = document.createElement("input");
      hp.type = "text";
      hp.name = HONEYPOT;
      hp.tabIndex = -1;
      hp.autocomplete = "off";
      hp.setAttribute("aria-hidden", "true");
      hp.style.cssText =
        "position:absolute;left:-9999px;width:1px;height:1px;opacity:0;";
      form.appendChild(hp);
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;

      var fd = new FormData(form);
      var payload = {};
      fd.forEach(function (value, key) {
        // Checkbox contact[tags] present only when ticked -> newsletter opt-in.
        payload[key] = value;
      });

      // Tell the proxy which Trak Racer storefront this is. The server maps the
      // hostname to the Zendesk store field; sending the header too is a second
      // source it can fall back to. Set window.TR_STORE to force a value (e.g.
      // on a *.myshopify.com preview host where the domain can't be detected).
      payload.shop_domain = window.location.hostname;
      if (window.TR_STORE) payload.store_value = window.TR_STORE;

      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          return r.json().catch(function () {
            return { ok: r.ok };
          });
        })
        .then(function (data) {
          if (data && data.ok) {
            showMessage(form, true);
            form.reset();
          } else {
            showMessage(form, false, data && data.error);
            if (btn) btn.disabled = false;
          }
        })
        .catch(function () {
          showMessage(form, false);
          if (btn) btn.disabled = false;
        });
    });
  }

  function showMessage(form, ok, error) {
    var existing = form.querySelector(".zd-proxy-note");
    if (existing) existing.remove();
    var note = document.createElement("p");
    note.className = "zd-proxy-note note " + (ok ? "note--success" : "note--error");
    note.setAttribute("role", "status");
    note.style.marginTop = "1rem";
    note.textContent = ok
      ? "Thanks! Your message has been received — we'll be in touch shortly."
      : error || "Sorry, something went wrong. Please try again or email us directly.";
    form.prepend(note);
    note.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function init() {
    // The section renders the form id as "contact-<section.id>".
    // document
    //   .querySelectorAll('form[id^="contact-"], form[action^="/contact"]')
    //   .forEach(enhance);
    document.querySelectorAll('form[id^="contact-custom-contact-form-v2"]').forEach(enhance);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
